"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerManager = void 0;
class TrackerManager {
    constructor(trackers) {
        this.trackers = [];
        this.track = (action, data) => {
            this.trackers.forEach(tracker => {
                tracker.track(action, data);
            });
        };
        this.trackers = [...trackers];
    }
}
exports.TrackerManager = TrackerManager;
//# sourceMappingURL=trackerManager.js.map